import { render, staticRenderFns } from "./ServiceConfigAdminEdit.vue?vue&type=template&id=54422355"
import script from "./ServiceConfigAdminEdit.vue?vue&type=script&lang=js"
export * from "./ServiceConfigAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports